import {UpperCasePipe} from '@angular/common'
import {Component, computed, inject, OnInit, signal} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {MatButton} from '@angular/material/button'
import {MatCard, MatCardContent} from '@angular/material/card'
import {MatDialog} from '@angular/material/dialog'
import {MatIcon} from '@angular/material/icon'
import {
  MatFormField,
  MatInput,
  MatLabel,
  MatPrefix
} from '@angular/material/input'
import {MatDivider} from '@angular/material/list'
import {ProjectService} from '../../services/project.service'
import {UserService} from '../../services/user-service'
import {ProjectButtons} from '../project-buttons/project-buttons'
import {NewProjectDialog} from '../quick-start-dialog/new-project-dialog.component'

@Component({
  selector: 'smt-projects',
  imports: [
    ProjectButtons,
    MatCard,
    MatCardContent,
    UpperCasePipe,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatPrefix,
    MatButton,
    MatDivider,
    FormsModule
  ],
  templateUrl: './projects.html',
  styleUrl: './projects.scss'
})
export class Projects implements OnInit {

  public readonly userService = inject(UserService)
  private readonly projectService = inject(ProjectService)
  private readonly dialog = inject(MatDialog)

  public searchQuery = signal('')
  public filteredProjects = computed(() => {

      if (!this.searchQuery()) {
        return this.projectService.projects()
      }

      return this.projectService.projects()
        .filter(project => `${project.projectName}${project.ownerName}`
          .toLowerCase()
          .replaceAll(/[\s-]/g, '')
          .includes(this.searchQuery()
            .toLocaleLowerCase()
            .replaceAll(/[\s-]/g, '')
          )
        )
    }
  )

  public ngOnInit() {
    this.projectService.getProjects().subscribe()
  }

  public newProject() {
    this.dialog.open(NewProjectDialog)
  }
}
